import { parseOrigin, CidMap } from '@foody/common';
export var isArray = function isArray(value) {
  return value instanceof Array;
};
export var isValidCid = function isValidCid(value, target) {
  if (!target) return false;
  return isArray(value) ? value.includes(target) : value === target;
};
export var showHideForCid = function showHideForCid(cid) {
  var _parseOrigin = parseOrigin(),
      _parseOrigin$cid = _parseOrigin.cid,
      curUrlCid = _parseOrigin$cid === void 0 ? CidMap.id : _parseOrigin$cid;

  return isValidCid(cid, curUrlCid);
};

var _parseOrigin2 = parseOrigin(),
    _parseOrigin2$cid = _parseOrigin2.cid,
    cid = _parseOrigin2$cid === void 0 ? CidMap.id : _parseOrigin2$cid,
    env = _parseOrigin2.env;

export { env, cid };
export var isTestENV = env === 'test';
/**
 * @abstract MultisiteWrapper 组件兼容 id/th/my 外的 country
 * @description 该组件使用过程中, 若 cid 未传 id/th/my 外的参数,例如 tw,则 tw 环境,子组件都将隐藏。考虑到其他环境仍可能使用, 同时不冗余字段, 对于 cid 在 id 生效的，在 th/my 外的地区也会生效。
 * @default tw/vn
 * @description 仅在 test 环境生效
 */

export var DefaultOthersSupportCid = isTestENV ? [CidMap.tw] : [];